/* unplugin-vue-components disabled */import __unplugin_components_1 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/DictTag/index.vue';
import __unplugin_components_0 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/RightToolbar/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " 平台 ", -1);
const _hoisted_3 = {
  class: "dialog-footer"
};
import { addMenu, delMenu, getMenu, listMenu, updateMenu } from "@/api/system/menu";
import SvgIcon from "@/components/SvgIcon";
import IconSelect from "@/components/IconSelect";
import { ClickOutside as vClickOutside } from "element-plus";
export default {
  __name: 'index',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const {
      sys_show_hide,
      sys_normal_disable
    } = proxy.useDict("sys_show_hide", "sys_normal_disable");
    const menuList = ref([]);
    const open = ref(false);
    const loading = ref(false);
    const showSearch = ref(true);
    const title = ref("");
    const menuOptions = ref([]);
    const isExpandAll = ref(false);
    const refreshTable = ref(true);
    const showChooseIcon = ref(false);
    const iconSelectRef = ref(null);
    const sys_platform = reactive({
      cyt: {
        label: "宠医通",
        value: "cyt"
      },
      cyb: {
        label: "宠医宝",
        value: "cyb"
      },
      cgj: {
        label: "宠管家",
        value: "cgj"
      },
      no: {
        label: "无",
        value: ""
      }
    });
    const options = reactive([
    // {label:'服务端管理',value:'服务端管理'},
    // {label:'管理首页',value:'管理首页'},
    //  {label:'报表中心',value:'报表中心'},
    //  {label:'财务管理',value:'财务管理'},
    //  {label:'档案管理',value:'档案管理'},
    //  {label:'人事管理',value:'人事管理'},
    //  {label:'系统管理',value:'系统管理'},

    {
      label: '管理中心',
      value: '管理中心'
    }, {
      label: '服务管理',
      value: '服务管理'
    }, {
      label: '档案管理',
      value: '档案管理'
    }, {
      label: '人事管理',
      value: '人事管理'
    }, {
      label: '财务管理',
      value: '财务管理'
    }, {
      label: '经营分析',
      value: '经营分析'
    }, {
      label: '费用管理',
      value: '费用管理'
    }, {
      label: '系统管理',
      value: '系统管理'
    }]);
    const data = reactive({
      form: {
        platform: ""
      },
      queryParams: {
        menuName: undefined,
        visible: undefined,
        platform: null
      },
      rules: {
        menuName: [{
          required: true,
          message: "菜单名称不能为空",
          trigger: "blur"
        }],
        orderNum: [{
          required: true,
          message: "菜单顺序不能为空",
          trigger: "blur"
        }],
        path: [{
          required: true,
          message: "路由地址不能为空",
          trigger: "blur"
        }]
      }
    });
    const {
      queryParams,
      form,
      rules
    } = toRefs(data);

    /** 查询菜单列表 */
    function getList() {
      loading.value = true;
      listMenu(queryParams.value).then(response => {
        menuList.value = proxy.handleTree(response.data, "menuId");
        loading.value = false;
      });
    }
    /** 查询菜单下拉树结构 */
    function getTreeselect() {
      menuOptions.value = [];
      listMenu({}).then(response => {
        const menu = {
          menuId: 0,
          menuName: "主类目",
          children: []
        };
        menu.children = proxy.handleTree(response.data, "menuId");
        menuOptions.value.push(menu);
      });
    }
    /** 取消按钮 */
    function cancel() {
      open.value = false;
      reset();
    }
    /** 表单重置 */
    function reset() {
      form.value = {
        menuId: undefined,
        parentId: 0,
        menuName: undefined,
        icon: undefined,
        menuType: "M",
        orderNum: undefined,
        isFrame: "1",
        isCache: "0",
        visible: "0",
        status: "0",
        platform: "cyt"
      };
      proxy.resetForm("menuRef");
    }
    /** 展示下拉图标 */
    function showSelectIcon() {
      console.log("showSelectIcon");
      iconSelectRef.value.reset();
      showChooseIcon.value = true;
    }
    /** 选择图标 */
    function selected(name) {
      form.value.icon = name;
      showChooseIcon.value = false;
    }
    /** 图标外层点击隐藏下拉列表 */
    function hideSelectIcon(event) {
      console.log("hideSelectIcon");
      var elem = event.relatedTarget || event.srcElement || event.target || event.currentTarget;
      var className = elem.className;
      if (className !== "el-input__inner") {
        showChooseIcon.value = false;
      }
    }
    /** 搜索按钮操作 */
    function handleQuery() {
      getList();
    }
    /** 重置按钮操作 */
    function resetQuery() {
      proxy.resetForm("queryRef");
      handleQuery();
    }
    /** 新增按钮操作 */
    function handleAdd(row) {
      reset();
      getTreeselect();
      if (row != null && row.menuId) {
        form.value.parentId = row.menuId;
      } else {
        form.value.parentId = 0;
      }
      console.log(row, 'row-----');
      form.value.rootNodeName = row.rootNodeName;
      open.value = true;
      title.value = "添加菜单";
    }
    /** 展开/折叠操作 */
    function toggleExpandAll() {
      refreshTable.value = false;
      isExpandAll.value = !isExpandAll.value;
      nextTick(() => {
        refreshTable.value = true;
      });
    }
    /** 修改按钮操作 */
    async function handleUpdate(row) {
      reset();
      await getTreeselect();
      getMenu(row.menuId).then(response => {
        form.value = response.data;
        open.value = true;
        title.value = "修改菜单";
      });
    }
    /** 提交按钮 */
    function submitForm() {
      proxy.$refs["menuRef"].validate(valid => {
        if (valid) {
          if (form.value.menuId != undefined) {
            console.log(form.value);
            updateMenu(form.value).then(response => {
              proxy.$modal.msgSuccess("修改成功");
              open.value = false;
              getList();
            });
          } else {
            addMenu(form.value).then(response => {
              proxy.$modal.msgSuccess("新增成功");
              open.value = false;
              getList();
            });
          }
        }
      });
    }
    /** 删除按钮操作 */
    function handleDelete(row) {
      proxy.$modal.confirm('是否确认删除名称为"' + row.menuName + '"的数据项?').then(function () {
        return delMenu(row.menuId);
      }).then(() => {
        getList();
        proxy.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    }
    getList();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_col = _resolveComponent("el-col");
      const _component_right_toolbar = __unplugin_components_0;
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_dict_tag = __unplugin_components_1;
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_tree_select = _resolveComponent("el-tree-select");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_search = _resolveComponent("search");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_question_filled = _resolveComponent("question-filled");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_component_el_form, {
        model: _unref(queryParams),
        ref: "queryRef",
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "菜单名称",
          prop: "menuName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(queryParams).menuName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(queryParams).menuName = $event),
            placeholder: "请输入菜单名称",
            clearable: "",
            onKeyup: _withKeys(handleQuery, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "状态",
          prop: "status"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(queryParams).status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(queryParams).status = $event),
            placeholder: "菜单状态",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_normal_disable), dict => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: dict.value,
                label: dict.label,
                value: dict.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "平台"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(queryParams).platform,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(queryParams).platform = $event),
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_platform), dict => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: dict.value,
                label: dict.label,
                value: dict.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: handleQuery
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          }), _createVNode(_component_el_button, {
            icon: "Refresh",
            onClick: resetQuery
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), [[_vShow, _unref(showSearch)]]), _createVNode(_component_el_row, {
        gutter: 10,
        class: "mb8"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            icon: "Plus",
            onClick: handleAdd
          }, {
            default: _withCtx(() => [_createTextVNode("新增")]),
            _: 1
          })]),
          _: 1
        }, 8, ["span"]), _createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "Sort",
            onClick: toggleExpandAll
          }, {
            default: _withCtx(() => [_createTextVNode("展开/折叠")]),
            _: 1
          })]),
          _: 1
        }, 8, ["span"]), _createVNode(_component_right_toolbar, {
          showSearch: _unref(showSearch),
          "onUpdate:showSearch": _cache[3] || (_cache[3] = $event => _isRef(showSearch) ? showSearch.value = $event : null),
          onQueryTable: getList
        }, null, 8, ["showSearch"])]),
        _: 1
      }), _unref(refreshTable) ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: _unref(menuList),
        "row-key": "menuId",
        "default-expand-all": _unref(isExpandAll),
        "tree-props": {
          children: 'children',
          hasChildren: 'hasChildren'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "menuName",
          label: "菜单名称",
          "show-overflow-tooltip": true,
          width: "160"
        }), _createVNode(_component_el_table_column, {
          prop: "icon",
          label: "图标",
          align: "center",
          width: "100"
        }, {
          default: _withCtx(scope => [_createVNode(_unref(SvgIcon), {
            "icon-class": scope.row.icon
          }, null, 8, ["icon-class"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "orderNum",
          label: "排序",
          width: "60"
        }), _createVNode(_component_el_table_column, {
          prop: "perms",
          label: "权限标识",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          prop: "component",
          label: "组件路径",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态",
          width: "80"
        }, {
          default: _withCtx(scope => [_createVNode(_component_dict_tag, {
            options: _unref(sys_normal_disable),
            value: scope.row.status
          }, null, 8, ["options", "value"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "platform",
          label: "平台",
          width: "80"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.platform && _unref(sys_platform)[scope.row.platform]?.label || ""), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "创建时间",
          align: "center",
          prop: "createTime"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(scope.row.createTime)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          width: "200",
          "class-name": "small-padding fixed-width"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Edit",
            link: "",
            onClick: $event => handleUpdate(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("修改")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Plus",
            link: "",
            onClick: $event => handleAdd(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("新增")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "default-expand-all"])), [[_directive_loading, _unref(loading)]]) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: _unref(title),
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _isRef(open) ? open.value = $event : null),
        width: "680px",
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "menuRef",
          model: _unref(form),
          rules: _unref(rules),
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "一级菜单"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).rootNodeName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).rootNodeName = $event),
                  clearable: "",
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "上级菜单"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                  modelValue: _unref(form).parentId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).parentId = $event),
                  data: _unref(menuOptions),
                  props: {
                    value: 'menuId',
                    label: 'menuName',
                    children: 'children'
                  },
                  "value-key": "menuId",
                  placeholder: "选择上级菜单",
                  "check-strictly": ""
                }, null, 8, ["modelValue", "data"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "菜单类型",
                prop: "menuType"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).menuType,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).menuType = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio, {
                    label: "M"
                  }, {
                    default: _withCtx(() => [_createTextVNode("目录")]),
                    _: 1
                  }), _createVNode(_component_el_radio, {
                    label: "C"
                  }, {
                    default: _withCtx(() => [_createTextVNode("菜单")]),
                    _: 1
                  }), _createVNode(_component_el_radio, {
                    label: "F"
                  }, {
                    default: _withCtx(() => [_createTextVNode("按钮")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _unref(form).menuType != 'F' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "菜单图标",
                prop: "icon"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_popover, {
                  placement: "bottom-start",
                  width: 540,
                  visible: _unref(showChooseIcon),
                  "onUpdate:visible": _cache[8] || (_cache[8] = $event => _isRef(showChooseIcon) ? showChooseIcon.value = $event : null),
                  trigger: "click",
                  onShow: showSelectIcon
                }, {
                  reference: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_input, {
                    modelValue: _unref(form).icon,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(form).icon = $event),
                    placeholder: "点击选择图标",
                    onBlur: showSelectIcon,
                    readonly: ""
                  }, {
                    prefix: _withCtx(() => [_unref(form).icon ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                      key: 0,
                      "icon-class": _unref(form).icon,
                      class: "el-input__icon",
                      style: {
                        "height": "32px",
                        "width": "16px"
                      }
                    }, null, 8, ["icon-class"])) : (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      style: {
                        "height": "32px",
                        "width": "16px"
                      }
                    }, {
                      default: _withCtx(() => [_createVNode(_component_search)]),
                      _: 1
                    }))]),
                    _: 1
                  }, 8, ["modelValue"])), [[_unref(vClickOutside), hideSelectIcon]])]),
                  default: _withCtx(() => [_createVNode(_unref(IconSelect), {
                    ref_key: "iconSelectRef",
                    ref: iconSelectRef,
                    onSelected: selected
                  }, null, 512)]),
                  _: 1
                }, 8, ["visible"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "菜单名称",
                prop: "menuName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).menuName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).menuName = $event),
                  placeholder: "请输入菜单名称"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "显示排序",
                prop: "orderNum"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  modelValue: _unref(form).orderNum,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).orderNum = $event),
                  "controls-position": "right",
                  min: 0
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _unref(form).menuType != 'F' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_tooltip, {
                  content: "选择是外链则路由地址需要以`http(s)://`开头",
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_question_filled)]),
                    _: 1
                  })]),
                  _: 1
                }), _createTextVNode("是否外链 ")])]),
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).isFrame,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).isFrame = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio, {
                    label: "0"
                  }, {
                    default: _withCtx(() => [_createTextVNode("是")]),
                    _: 1
                  }), _createVNode(_component_el_radio, {
                    label: "1"
                  }, {
                    default: _withCtx(() => [_createTextVNode("否")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _unref(form).menuType != 'F' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 2,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "path"
              }, {
                label: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_tooltip, {
                  content: "访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头",
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_question_filled)]),
                    _: 1
                  })]),
                  _: 1
                }), _createTextVNode(" 路由地址 ")])]),
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).path,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(form).path = $event),
                  placeholder: "请输入路由地址"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _unref(form).menuType == 'C' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 3,
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "component"
              }, {
                label: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_tooltip, {
                  content: "访问的组件路径，如：`system/user/index`，默认在`views`目录下",
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_question_filled)]),
                    _: 1
                  })]),
                  _: 1
                }), _createTextVNode(" 组件路径 ")])]),
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).component,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(form).component = $event),
                  placeholder: "请输入组件路径"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _unref(form).menuType != 'M' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 4,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_tooltip, {
                  content: "控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)",
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_question_filled)]),
                    _: 1
                  })]),
                  _: 1
                }), _createTextVNode(" 权限字符 ")])]),
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).perms,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(form).perms = $event),
                  placeholder: "请输入权限标识",
                  maxlength: "100"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _unref(form).menuType == 'C' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 5,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_tooltip, {
                  content: "访问路由的默认传递参数，如：`{\"id\": 1, \"name\": \"ry\"}`",
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_question_filled)]),
                    _: 1
                  })]),
                  _: 1
                }), _createTextVNode(" 路由参数 ")])]),
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).query,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(form).query = $event),
                  placeholder: "请输入路由参数",
                  maxlength: "255"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _unref(form).menuType == 'C' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 6,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_tooltip, {
                  content: "选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致",
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_question_filled)]),
                    _: 1
                  })]),
                  _: 1
                }), _createTextVNode(" 是否缓存 ")])]),
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).isCache,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(form).isCache = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio, {
                    label: "0"
                  }, {
                    default: _withCtx(() => [_createTextVNode("缓存")]),
                    _: 1
                  }), _createVNode(_component_el_radio, {
                    label: "1"
                  }, {
                    default: _withCtx(() => [_createTextVNode("不缓存")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _unref(form).menuType != 'F' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 7,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_tooltip, {
                  content: "选择隐藏则路由将不会出现在侧边栏，但仍然可以访问",
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_question_filled)]),
                    _: 1
                  })]),
                  _: 1
                }), _createTextVNode(" 显示状态 ")])]),
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).visible,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(form).visible = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_show_hide), dict => {
                    return _openBlock(), _createBlock(_component_el_radio, {
                      key: dict.value,
                      label: dict.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                      _: 2
                    }, 1032, ["label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _unref(form).menuType != 'F' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 8,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_tooltip, {
                  content: "选择停用则路由将不会出现在侧边栏，也不能被访问",
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_question_filled)]),
                    _: 1
                  })]),
                  _: 1
                }), _createTextVNode(" 菜单状态 ")])]),
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).status,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _unref(form).status = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_normal_disable), dict => {
                    return _openBlock(), _createBlock(_component_el_radio, {
                      key: dict.value,
                      label: dict.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                      _: 2
                    }, 1032, ["label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                label: _withCtx(() => [_hoisted_2]),
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).platform,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(form).platform = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_platform), dict => {
                    return _openBlock(), _createBlock(_component_el_radio, {
                      key: dict.value,
                      label: dict.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                      _: 2
                    }, 1032, ["label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["title", "modelValue"])]);
    };
  }
};